export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      return await navigator.serviceWorker.register("/firebase-messaging-sw.js", { scope: "/" });
    } catch (err) {
      return err;
    }
  }
};

export const unRegisterServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await registrations?.forEach((registration) => registration.unregister());
    } catch (err) {
      return err;
    }
  }
};
